import { combineReducers } from 'redux';
import me from './me';
import * as fromMe from './me';
import groups from './groups/groups';
import * as fromGroups from './groups/groups';
import del from './del';
import * as fromDel from './del';
import users from './users/users';
import * as fromUsers from './users/users';
import currentTab from './currentTab';
import * as fromCurrentTab from './currentTab';

export default combineReducers({
  me,
  groups,
  users,
  del,
  currentTab,
});

export const getMyPermissions = (state) => fromMe.getMyPermissions(state.me);

export const isFetchingMyPermissions = (state) => fromMe.isFetchingMyPermissions(state.me);

export const getUpdatingGroup = (state) => fromGroups.getUpdatingGroup(state.groups);

export const isUpdatingGroup = (state) => fromGroups.isUpdatingGroup(state.groups);

export const getGroups = (state) => fromGroups.getGroups(state.groups);

export const isFetchingGroups = (state) => fromGroups.isFetchingGroups(state.groups);

export const getUpdatingUser = (state) => fromUsers.getUpdatingUser(state.users);

export const isUpdatingUser = (state) => fromUsers.isUpdatingUser(state.users);

export const getUsers = (state) => fromUsers.getUsers(state.users);

export const isFetchingUsers = (state) => fromUsers.isFetchingUsers(state.users);

export const isDeletingEntity = (state) => fromDel.isDeleting(state.del);

export const getTabKey = (state) => fromCurrentTab.getTabKey(state.currentTab);
